import { createFileRoute } from "@tanstack/react-router";

import { ScreeningPage } from "@/features/screening/ScreeningPage";

export const Route = createFileRoute("/_app/screenings/$screeningId")({
  component: function ScreeningRoute() {
    const { screeningId } = Route.useParams();
    return <ScreeningPage key={screeningId} screeningId={screeningId} />;
  },
});
